import { render, staticRenderFns } from "./SubscriptionByvendor.vue?vue&type=template&id=2880e210&scoped=true&"
import script from "./SubscriptionByvendor.vue?vue&type=script&lang=js&"
export * from "./SubscriptionByvendor.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionByvendor.vue?vue&type=style&index=0&id=2880e210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880e210",
  null
  
)

export default component.exports